class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  getPredictiveSearchElement() {
    // Check screen size and return appropriate element
    if (window.innerWidth >= 1450) {
      return document.querySelector('#predictive-search.desktop');
    } else {
      return document.querySelector('.hd_searchbox.mobile #predictive-search');
    }
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      const predictiveSearchResults = this.getPredictiveSearchElement();
      if (predictiveSearchResults) {
        predictiveSearchResults.innerHTML = resultsMarkup;
      }
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    const predictiveSearchResults = this.getPredictiveSearchElement();
    if (predictiveSearchResults) {
      predictiveSearchResults.style.display = 'block';
    }
    this.classList.add('enable_search');
  }
  close() {
    const predictiveSearchResults = this.getPredictiveSearchElement();
    if (predictiveSearchResults) {
      predictiveSearchResults.style.display = 'none';
    }
    this.classList.remove('enable_search');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
$(document).on('click','.rp_search',function (e) {
  e.preventDefault();
  $('body').toggleClass('search-open');
  $('body').removeClass('menu-open');
  $('#Search').focus();
  //searchPosition();
});
$(document).on('click','.desk_h_icon.search .hd_searchbox',function (e) {
  e.stopPropagation(); // Prevent closing when clicking inside search box
});
$(document).on('click','.closesearch',function (e) {
  e.preventDefault();
  $('body').removeClass('search-open');
  $('#Search').val('');
  // Hide both predictive search elements
  $('#predictive-search.desktop, .hd_searchbox.mobile #predictive-search').hide();
  $(this).closest('predictive-search').removeClass('enable_search');
});
$(document).on('click','.box-overlay',function (e) {
  e.preventDefault();
  $('body').removeClass('search-open menu-open');
});
$(document).on('click','.nextlevel_url',function (e) {
  e.preventDefault();
  $(this).next('.mob_nextlevel').addClass('active');
});
$(document).on('click','.back_m_menu',function (e) {
  e.preventDefault();
  $(this).closest('.mob_nextlevel').removeClass('active');
});
$(document).on('click','.menuclose,.header-overlay',function (e) {
  e.preventDefault();
  $('body').removeClass('menu-open search-open')
  $('.mob_nextlevel').removeClass('active');
});
$(document).on('click','.menu-burger',function (e) {
  e.preventDefault();
  $('body').addClass('menu-open');
  $('body').removeClass('search-open');
});


$("body").on("click", function (e) {
  var seachbox = $("#predictive-search-results,.snippet-search-bar,.rp_m_search,.mob_h_icon");
  if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0) {
    $("body").removeClass("open-search");
    // Hide both predictive search elements
    $("#predictive-search.desktop, .hd_searchbox.mobile #predictive-search").hide();
    $("#Search").val("");
    $('body').removeClass('search-open');
  }
});
// searchPosition();
// function searchPosition() {
//   if ($(window).width() < 992) {
//     var deskSearch = $(".header_group").height() + $(".snippet-search-bar").height();
//     $("#predictive-search").css({
//       top: deskSearch,
//       height: "calc(100% - " + deskSearch + "px)",
//     });
//   }
// }
// $(window).on("scroll", function (e) {
//   searchPosition();
// });